﻿import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@blueprintjs/core";
import classNames from "classnames";
import "./MediaPlaceholder.css";
import './DocumentViewer.css';
import './ImageCropper.css';
import './MediaList.css';

export function MediaPlaceholder({
    message = "No media available",
    size = "medium"
}) {
    return (
        <div className={classNames("media-placeholder", size)}>
            <Icon icon="camera" className="media-placeholder-icon" />
        </div>
    );
}

MediaPlaceholder.propTypes = {
    message: PropTypes.string,
    size: PropTypes.oneOf(["small", "medium", "large"]),
};
